import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ActionControlsSections"*/ './lazyIndex'),
    { name: 'ActionControlsSections' }
);

export const lazyGetTableSections: LazyImport<
    typeof lazyIndex.getTableSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTableSections);
export const lazyGetLinkUnlinkSections: LazyImport<
    typeof lazyIndex.getLinkUnlinkSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getLinkUnlinkSections);
export const lazyContentPickerSection: LazyImport<
    typeof lazyIndex.getContentPickerSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getContentPickerSections);
export const lazyGetBoostSections: LazyImport<
    typeof lazyIndex.getBoostSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getBoostSections);
export const lazyGetDictationLanguagePickerMenuSections: LazyImport<
    typeof lazyIndex.getDictationLanguagePickerMenuSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getDictationLanguagePickerMenuSections);
